/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import AlarmDetailsDialogController from './alarm-details-dialog.controller';
import AlarmHeaderDirective from './alarm-header.directive';
import AlarmRowDirective from './alarm-row.directive';
import AlarmTableDirective from './alarm-table.directive';

export default angular.module('thingsboard.alarm', [])
    .controller('AlarmDetailsDialogController', AlarmDetailsDialogController)
    .directive('tbAlarmHeader', AlarmHeaderDirective)
    .directive('tbAlarmRow', AlarmRowDirective)
    .directive('tbAlarmTable', AlarmTableDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/alarm/index.js